import React from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import {Editor} from '../editor-components';
import Spinner from '../spinner/spinner';
import ScreenEmulator from '../screen-emulator/screen-emulator';

/** @class BothReviewer
  * A component for reviewing and approving booths and thier contents
  * in a virutal expo.
  */
export default class BoothReviewer extends ReactFireComponent {
  /** @constructor
    * Creates a new BoothEditor component
    */
  constructor(props) {
    super(props);
    const expoID = props.match.params.expoID
    const showID = props.match.params.showID
    const boothID = props.match.params.boothID
    this.state = {
      expoID: expoID,
      showID: showID,
      boothID: boothID
    }
    this.dataURL = `/expos/${expoID}/shows/${showID}/booths/${boothID}`;
    this.hallURL = `/expos/${expoID}/shows/${showID}/halls`;
  }
  /** @function componentWillMount
    * Connects the component to its corresponding
    * data in the Firebase realtime database
    */
  componentWillMount() {
    window.dataURL = this.dataURL;
    this.bindAsObject(this.dataURL, 'booth');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the
    * Firebase realtime database
    */
  componentWillUnmount() {
    this.unbind('booth');
  }
  /** @function render
    * Renders the component
    */
  render(){
    if(!this.state.booth) return <Spinner />
    return(
      <Editor>
        <ScreenEmulator src={`/preview/${this.state.expoID}/${this.state.showID}/#/booth-review/${this.state.boothID}`} />
      </Editor>
    );
  }
}



// WEBPACK FOOTER //
// ./src/booth-reviewer/booth-reviewer.js